import { render } from "./CorrectReasonView.vue?vue&type=template&id=585f16dc&scoped=true&ts=true"
import script from "./CorrectReasonView.vue?vue&type=script&lang=ts"
export * from "./CorrectReasonView.vue?vue&type=script&lang=ts"

import "./CorrectReasonView.vue?vue&type=style&index=0&id=585f16dc&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\fushuliang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-585f16dc"]])

export default __exports__